import EventModel            from '@/models/services/website/EventModel';
import WebsiteUserModel      from '@/models/services/website/WebsiteUserModel';
import WebsiteServiceModel   from '@/models/WebsiteServiceModel';
import doc                   from '@widesk-core/decorators/doc';

export default class UserEventModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'event': id;
		'event.websiteEntertainment': id;
	};

	static get path(): string {
		return 'user_events/{?id}';
	}

	@doc.model(WebsiteUserModel) declare user: WebsiteUserModel;
	@doc.model(EventModel) declare event: EventModel;
	@doc.string declare createdBy: string;
	@doc.string declare updatedBy: string;
	@doc.date declare createdAt: Dayjs;
	@doc.date declare updatedAt: Dayjs;
}